module.exports = __webpack_public_path__ + "img/terrazza-011.b55bb9c5.jpg";